/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable jsdoc/require-jsdoc */

import { decryptData, reverseStringValue } from '@/helpers'
import offlineDB from '@/indexeddb'
import sessionsDB from '@/indexeddb/sessions'
import {
  EUserPermissionType,
  type TAuthUserPermission,
  type TAuthUserPermissionResponse,
  type IMenuItem,
  type TSignIn,
  type TAuthCurrentUserState,
  type TConvocatoria,
  type TEntityInfo,
} from '@/interfaces'

export const getRoutePathsFromMenu = (menuItems: IMenuItem[]): string[] => {
  const pathsList: string[] = []

  menuItems.forEach((element: IMenuItem) => {
    if (Array.isArray(element.children) && element.children?.length > 0) {
      pathsList.push(...getRoutePathsFromMenu(element.children))
    }

    if (element.url !== undefined) {
      pathsList.push(element.url)
    }
  })

  return pathsList
}

export function setUserPermissions(
  permissions: TAuthUserPermissionResponse[]
): Record<string, TAuthUserPermission> {
  const userPermissions: Record<string, TAuthUserPermission> = {}

  permissions.forEach((item) => {
    const entityName = item.entity

    const createPermission = item.permission.create
    const deletePermission = item.permission.delete
    const editPermission = item.permission.edit
    const readPermission = item.permission.read
    const streamPermission = item.permission.stream

    userPermissions[entityName] = {
      create: createPermission
        ? createPermission !== EUserPermissionType.NO
        : false,
      delete: deletePermission
        ? deletePermission !== EUserPermissionType.NO
        : false,
      edit: editPermission ? editPermission !== EUserPermissionType.NO : false,
      read: readPermission ? readPermission !== EUserPermissionType.NO : false,
      stream: streamPermission
        ? streamPermission !== EUserPermissionType.NO
        : false,
    }
  })

  return userPermissions
}

export async function getOfflineUserId(
  signinData: TSignIn
): Promise<string | null> {
  const sessions = await sessionsDB.getAllFromStore()

  const userInfo = sessions.find((item) => {
    const itemData = decryptData(item.data as string)
    const itemDataValues = itemData ? JSON.parse(itemData) : null

    return Boolean(
      itemDataValues &&
        itemDataValues.username === signinData.username &&
        itemDataValues.password === signinData.password
    )
  })

  return userInfo?.id ? reverseStringValue(userInfo.id as string) : null
}

export async function getOfflineDataByUser(): Promise<{
  convocatorias: TConvocatoria[]
  formEntities: TEntityInfo[]
  token: string
  userData: TAuthCurrentUserState
}> {
  const [userSession, tokenSession, convocatoriasSession, formEntitiesSession] =
    await Promise.all([
      offlineDB.getFromStore(
        offlineDB.stores.USER_STORE,
        offlineDB.userStoreIds.user
      ),
      offlineDB.getFromStore(
        offlineDB.stores.USER_STORE,
        offlineDB.userStoreIds.token
      ),
      offlineDB.getFromStore(
        offlineDB.stores.USER_STORE,
        offlineDB.userStoreIds.convocatorias
      ),
      offlineDB.getFromStore(
        offlineDB.stores.USER_STORE,
        offlineDB.userStoreIds.formEntities
      ),
    ])

  const userData: TAuthCurrentUserState = JSON.parse(
    decryptData(userSession.data as string)
  )
  const token: string = decryptData(tokenSession.data as string)
  const convocatorias: TConvocatoria[] = JSON.parse(
    decryptData(convocatoriasSession.data as string)
  )
  const formEntities: TEntityInfo[] = JSON.parse(
    decryptData(formEntitiesSession.data as string)
  )

  return {
    convocatorias,
    formEntities,
    token,
    userData,
  }
}
